import { Outlet } from "react-router-dom";

const MailTemplateLayout = () => {
  return <Outlet />;
};

export default MailTemplateLayout;